import { render, staticRenderFns } from "./RunningCampaigns.vue?vue&type=template&id=4bb0866d&scoped=true"
import script from "./RunningCampaigns.vue?vue&type=script&lang=ts"
export * from "./RunningCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb0866d",
  null
  
)

export default component.exports